import { Injectable } from '@angular/core';

import { DateDiff } from 'angular-library';

import { STATI, Dirette, TimeInfo, StatiDirette } from '../../shared/shared.module';

@Injectable()
export class TimeInfoService {

    getTime(diretta: Dirette): TimeInfo {
        let minuti_correnti: number = null;
        let extraTime_correnti: number = null;
        if (diretta.stato > STATI.NON_INIZIATO && diretta.stato < STATI.FINE_PARTITA) {
            let baseTime = this.getBaseTime(diretta);
            let tempoRegolamentare: number = baseTime.max - baseTime.min;
            if (diretta.statoCorrente.events_allowed == 1 && diretta.stato != STATI.RIGORI) {
                let minDiff = DateDiff.getMinutes(new Date(diretta.inizioStatoCorrente), new Date());
                if (minDiff > tempoRegolamentare) {
                    minuti_correnti = baseTime.max;
                    extraTime_correnti = minDiff - tempoRegolamentare;
                } else {
                    minuti_correnti = baseTime.min + minDiff;
                    extraTime_correnti = 0;
                }
            } else {
                minuti_correnti = baseTime.min;
                extraTime_correnti = 0;
            }
        }
        
        if (diretta.stato == STATI.FINE_PARTITA) {
            extraTime_correnti = 0;
            let statoDiretta: StatiDirette = this.getMaxStatoDiretta(diretta);
            minuti_correnti = statoDiretta.max_time
        }

        let result: TimeInfo = new TimeInfo();
        result.minuti_correnti = minuti_correnti;
        result.extraTime_correnti = extraTime_correnti;
        return result;
    }

    getBaseTime(diretta: Dirette): any {
        let statoDiretta: StatiDirette = this.getMaxStatoDiretta(diretta);
        let result: any = {};
        result.min = statoDiretta.min_time;
        result.max = statoDiretta.max_time;
        return result;
    }

    getMaxStatoDiretta(diretta): StatiDirette {
        let maxStato: number = 0;
        if (diretta.stato == STATI.FINE_PARTITA) {
            diretta.eventiDiretta.filter(y => y.stato_diretta < STATI.FINE_PARTITA).forEach(x => {
                if (x.stato_diretta > maxStato) maxStato = x.stato_diretta;
            });
        } else maxStato = diretta.stato;
        let statoDiretta: StatiDirette = diretta.statiDirette.find(x => x.id == maxStato);
        return statoDiretta;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/time-info.service.ts